import { AppLanguage, IUfinetSelectOption } from 'ufinet-web-functions'

export class NetworkElementType {
	networkElementTypeId: string
	nameEs: string
	nameEn: string
	namePt: string

	constructor(id: string, nameEs: string, nameEn: string, namePt: string) {
		this.networkElementTypeId = id
		this.nameEs = nameEs
		this.nameEn = nameEn
		this.namePt = namePt
	}

	static mapNetworkElementTypeToSelectOption(self: NetworkElementType, language: AppLanguage): IUfinetSelectOption {
		return {
			label: language === 'es' ? self.nameEs : language === 'en' ? self.nameEn : self.namePt,
			value: self.networkElementTypeId,
		}
	}
}
